module.exports = __webpack_public_path__ + "img/tencent-oa-qrcode-1.01a5cd50.png";